import { Component, Input } from '@angular/core'
import { OrderPatch, OrderRead, OrdersService, StatusRead } from '@app/generated'
import { NotificationService } from '@core/services/notification.service'
import { FormControl, FormGroup } from '@angular/forms'
import { ModalService } from '@core/services/modal.service'
import { finalize } from 'rxjs'
import { LoaderService } from '@core/services/loader.service'
import { getItemTranslation } from '@app/general/utils/get-item-translation'

@Component({
	selector: 'order-status-update',
	templateUrl: './order-status-update.component.html',
	styleUrl: './order-status-update.component.scss',
})
export class OrderStatusUpdateComponent {
	@Input() order: OrderRead = {} as OrderRead
	@Input() category: 'container-clearance' | 'container-logistic' | 'order-payment' | null = null
	statuses: StatusRead[] = []
	orderPath: OrderPatch = {} as OrderPatch
	statusTypeForm = {
		formGroup: new FormGroup({
			statusType: new FormControl<StatusRead | null>(null),
		}),
	}
	protected readonly getItemTranslation = getItemTranslation
	protected readonly confirmButtonText = $localize`Confirm`
	protected readonly cancelButtonText = $localize`Cancel`

	constructor(
		private ordersService: OrdersService,
		private notificationService: NotificationService,
		private modalService: ModalService,
		private loaderService: LoaderService,
	) {}

	ngOnInit() {
		this.fetchData()
		let status: StatusRead | null | undefined = undefined
		if (this.category == 'container-clearance') {
			status = this.order.container_clearance_status
		} else if (this.category == 'container-logistic') {
			status = this.order.container_logistic_status
		} else if (this.category == 'order-payment') {
			status = this.order.order_payment_status
		}
		this.statusTypeForm.formGroup.patchValue({
			statusType: status!,
		})
	}

	fetchData() {
		if (this.category) {
			this.ordersService.getStatuses(this.category).subscribe({
				next: (response: StatusRead[]) => {
					this.statuses = response
				},
				error: error => {
					let message = $localize`Was not able to fetch conveyance types`
					if (error.code === 422) {
						message = $localize`Form contains errors`
					}
					this.notificationService.error(message)
				},
			})
		}
	}

	updateStatus() {
		if (this.category == 'order-payment') {
			this.orderPath = {
				order_payment_status_id: this.statusTypeForm.formGroup.controls['statusType'].value?.id,
			}
		} else if (this.category == 'container-clearance') {
			this.orderPath = {
				container_clearance_status_id: this.statusTypeForm.formGroup.controls['statusType'].value?.id,
			}
		} else if (this.category == 'container-logistic') {
			this.orderPath = {
				container_logistic_status_id: this.statusTypeForm.formGroup.controls['statusType'].value?.id,
			}
		}

		this.patchData(this.order)
	}

	cancelUpdateConveyanceType() {
		this.modalService.modalRef.close(false)
	}

	private patchData(order: OrderRead) {
		if (order.id) {
			this.ordersService
				.patchOrder(order.id, this.orderPath)
				.pipe(finalize(() => this.loaderService.disable()))
				.subscribe({
					next: () => {
						const newValue = this.statuses.find(
							status => status.id === this.statusTypeForm.formGroup.controls['statusType'].value?.id,
						)
						this.modalService.modalRef.close(newValue)
						this.notificationService.success($localize`Order conveyance type has been updated`)
					},
					error: () => {
						this.notificationService.error($localize`Failed to patch order conveyance type`)
					},
				})
		}
	}
}
